// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export const environment = {
    production: false,
    ga: '',
    firebase: {
        apiKey: 'AIzaSyB1W8Ztfv0tWdw8ZuW9JwQ_gl6UuAfcVT0',
        authDomain: 'fir-babycloud.firebaseapp.com',
        databaseURL: 'https://fir-babycloud.firebaseio.com',
        projectId: 'firebase-babycloud',
        storageBucket: 'firebase-babycloud.appspot.com',
        messagingSenderId: '360769880911',
        appId: '1:360769880911:web:ddd75a44cc210b9e52bb3a',
        measurementId: 'G-YK8Z5VHYCW',
        vapidKey: 'BNtkFm5cJM_CC_t7pzmFezA1QO6rTF1CNSFfOVmLSvC5R3Q4Eqgjt0VR-eHSPZfz6M7jtkKo0i--SGg5tEx_xCo'
    },
    apiUrl: 'https://dev.kilobytelab.com/babycloud/',
    siteKeyV3: '6LdbliwdAAAAAN7OueNhmhvWPiS-zQaldzONb_px',
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
